import { useHistory } from 'react-router-dom';
import { useNavHistory } from './NavigationHistoryContext';

import Button from '@mui/material/Button';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

//CSS Styles
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses'; 


const BackButton = (props) => {
  const classes = useClasses(flexstyles);
  const history = useHistory();
  const { popPage } = useNavHistory();

  const handleBack = () => {
    popPage(); // Remove current page from stack
    const previous = popPage(); // Get actual previous page

    if (previous) {
      //Adjust so that the database gets reloaded
      previous.localstate.dbreload = true;
      history.push(previous.pathname, {
        localstate: previous.localstate
      });
    } else {
      history.push(props.defaultbacklink ? props.defaultbacklink : '/'); // fallback route
    }
  };

  return (
  <Button
  className={classes.bluebtn}
  color="primary" variant="contained"
  onClick={() => handleBack()}>
  <KeyboardBackspaceIcon sx={{ color: "lightgray" }}></KeyboardBackspaceIcon>&nbsp;{props.text}
</Button>
  )
};

export default BackButton;